import { render, staticRenderFns } from "./app-spinner.vue?vue&type=template&id=68695b45"
import script from "./app-spinner.vue?vue&type=script&lang=ts"
export * from "./app-spinner.vue?vue&type=script&lang=ts"
import style0 from "./app-spinner.vue?vue&type=style&index=0&id=68695b45&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68695b45')) {
      api.createRecord('68695b45', component.options)
    } else {
      api.reload('68695b45', component.options)
    }
    module.hot.accept("./app-spinner.vue?vue&type=template&id=68695b45", function () {
      api.rerender('68695b45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-spinner/app-spinner.vue"
export default component.exports